// pages/GoverningBody.jsx
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
// import ProfileCard from "../components/ProfileCard";
// import SectionHeader from "../components/SectionHeader";
// import AnimatedPage from "../components/AnimatedPage";
import { governingBodyData } from "../data/governingBodyData";
import AnimatedPage from "../component/LeadershipComponents/AnimatedPage";
import SectionHeader from "../component/LeadershipComponents/SectionHeader";
import ProfileCard from "../component/LeadershipComponents/ProfileCard";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import HeadingWithWatermark from "../component/HeadingWithWatermark";

const GoverningBody = () => {
  const navigate = useNavigate();
  const chairpersonRef = useRef(null);
  const isChairInView = useInView(chairpersonRef, { once: true, amount: 0.3 });

  const handleCardClick = (id) => {
    navigate(`/governing-body/${id}`);
  };

  // Combine chairperson and members for suggestions later, or treat separately
  const allMembers = governingBodyData.chairperson
    ? [governingBodyData.chairperson, ...governingBodyData.members]
    : governingBodyData.members;

  return (
    
    <AnimatedPage>
      <Navbar/>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-white">
        {/* If chairperson exists, show a special section similar to Chairman */}
        {/* {governingBodyData.chairperson && (
          <section ref={chairpersonRef} className="mb-24">
            <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl shadow-xl overflow-hidden border border-blue-100">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={isChairInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className="h-full"
                >
                  <img
                    src={governingBodyData.chairperson.image}
                    alt={governingBodyData.chairperson.name}
                    className="w-full h-full object-cover object-center rounded-l-3xl"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  animate={isChairInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                  className="p-12"
                >
                  <h2 className="text-4xl font-bold text-blue-900 mb-6">
                    From the Chairperson
                  </h2>
                  <p className="text-2xl text-gray-700 italic leading-relaxed">
                    "{governingBodyData.chairperson.message}"
                  </p>
                  <p className="mt-6 text-xl font-semibold text-blue-800">
                    — {governingBodyData.chairperson.name}
                  </p>
                  <p className="text-blue-600">{governingBodyData.chairperson.designation}</p>
                </motion.div>
              </div>
            </div>
          </section>
        )} */}

        {/* Governing Body Members Grid */}
        <section>
            
             <HeadingWithWatermark className="mb-"
          title="Governing Body"
          watermarkText="Leadership"
          color="#1b73a7"
          align="center"
        />
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={{
              visible: { transition: { staggerChildren: 0.1 } }
            }}
          >
            {(governingBodyData.chairperson
              ? governingBodyData.members // exclude chairperson from grid if shown separately
              : governingBodyData.members
            ).map((person) => (
              <motion.div
                key={person.id}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0 }
                }}
                transition={{ duration: 0.5, ease: "easeOut" }}
              >
                <ProfileCard person={person} onClick={handleCardClick} />
              </motion.div>
            ))}
          </motion.div>
        </section>
      </div>
      <Footer/>
    </AnimatedPage>
  );
};



export default GoverningBody;